export const LABEL = "There are no answered questions or you didn't finished answering this form";
export const IMG_ALT = 'No question answered';
